import { useMemo } from 'react';
import { useCurrentUser } from '../hook';
import useAsset from '../hook/useAsset';
export var useUserRole = function() {
    var user = useCurrentUser().user;
    var constants = useAsset().constants;
    var _useMemo = useMemo(function() {
        if (!user) return {};
        var tmp = user.is_ops, isOps = tmp === void 0 ? false : tmp;
        var _user_organization_membership = user.organization_membership, isActive = _user_organization_membership.is_active, role = _user_organization_membership.role;
        return {
            isAdmin: isActive && role === constants.ORGANIZATION_ROLE_ADMIN,
            isUser: isActive && role === constants.ORGANIZATION_ROLE_USER,
            isCustomerSuccess: isActive && role === constants.ORGANIZATION_ROLE_CUSTOMER_SUCCESS,
            isOps: isActive && isOps
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        JSON.stringify(user),
        constants
    ]), _useMemo_isAdmin = _useMemo.isAdmin, isAdmin = _useMemo_isAdmin === void 0 ? false : _useMemo_isAdmin, _useMemo_isUser = _useMemo.isUser, isUser = _useMemo_isUser === void 0 ? false : _useMemo_isUser, _useMemo_isCustomerSuccess = _useMemo.isCustomerSuccess, isCustomerSuccess = _useMemo_isCustomerSuccess === void 0 ? false : _useMemo_isCustomerSuccess, _useMemo_isOps = _useMemo.isOps, isOps = _useMemo_isOps === void 0 ? false : _useMemo_isOps;
    return {
        isAdmin: isAdmin,
        isUser: isUser,
        isCustomerSuccess: isCustomerSuccess,
        isOps: isOps
    };
};
